/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

import { useEffect, useRef, useState } from 'react'
import { BA_IMAGES } from '../data/ba.js'
import { BaArrow } from './icons.jsx'

const SPREAD = [0, 0.99, 1.84, 2.6, 3.3]
const START = 3

export default function BeforeAfter() {
  const n = BA_IMAGES.length
  const [cur, setCur] = useState(START)
  const startX = useRef(null)
  const go = (k) => setCur(((k % n) + n) % n)

  useEffect(() => {
    const onUp = (e) => {
      if (startX.current === null) return
      const dx = e.clientX - startX.current
      startX.current = null
      if (Math.abs(dx) > 40) setCur((c) => (((c + (dx > 0 ? 1 : -1)) % n) + n) % n)
    }
    window.addEventListener('pointerup', onUp)
    return () => window.removeEventListener('pointerup', onUp)
  }, [n])

  return (
    <section id="ba" className="ba" aria-label="قبل و بعد">
      <h2 className="tm-title">قبل و بعد</h2>
      <div className="ba-stage" onPointerDown={(e) => (startX.current = e.clientX)}>
        <div className="ba-frame" aria-hidden="true"></div>
        {BA_IMAGES.map((src, i) => {
          let d = i - cur
          if (d > n / 2) d -= n
          if (d < -n / 2) d += n
          const ad = Math.abs(d)
          return (
            <article
              key={src}
              className={'ba-card' + (d === 0 ? ' is-c' : '')}
              aria-roledescription="slide"
              aria-hidden={d === 0 ? 'false' : 'true'}
              data-ad={ad}
              style={{ '--d': d, '--ad': ad, '--x': (d < 0 ? -1 : 1) * SPREAD[Math.min(ad, 4)], zIndex: 10 - ad }}
              onClick={() => i !== cur && go(i)}
            >
              <img
                src={src + '-720.webp'}
                srcSet={`${src}-480.webp 480w, ${src}-720.webp 720w`}
                sizes="(max-width:767px) 256px, 340px"
                alt="نتیجه‌ی شاگرد سکویا"
                width="720"
                height="1083"
                loading="lazy"
                decoding="async"
                draggable="false"
              />
            </article>
          )
        })}
      </div>
      <div className="ba-nav">
        <button type="button" className="ba-arrow ba-prev" aria-label="قبلی" onClick={() => go(cur - 1)}>
          <BaArrow />
        </button>
        <div className="ba-dots">
          {BA_IMAGES.map((src, i) => (
            <button key={src} type="button" className={'ba-dot' + (i === cur ? ' is-on' : '')} aria-label={'نمونه ' + (i + 1)} onClick={() => go(i)} />
          ))}
        </div>
        <button type="button" className="ba-arrow ba-next" aria-label="بعدی" onClick={() => go(cur + 1)}>
          <BaArrow />
        </button>
      </div>
    </section>
  )
}
